import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accounts: {},
};

const accountSlice = createSlice({
  name: "accounts",
  initialState,
  reducers: {
    setAccounts: (state, action) => {
      for (let i = 0; i < action.payload.length; i++) {
        let element = action.payload[i];
        if (state.accounts.hasOwnProperty(element.item_id)) {
          state.accounts[element.item_id].name = element.name;
          state.accounts[element.item_id].balance = element.balance;
        } else {
          state.accounts[element.item_id] = {
            name: element.name,
            balance: element.balance,
            transactions: [],
          };
        }
      }
    },
    setTransactions: (state, action) => {

      for (let i = 0; i < action.payload.length; i++) {
        let element = action.payload[i];
        state.accounts[element.item_id].transactions = element.transactions;
      }
    },
  },
});

export default accountSlice.reducer;

export const { setAccounts, setTransactions } = accountSlice.actions;
